import { createStandardAction } from 'typesafe-actions';
import { AccessibilitySettings, Auth } from '@lon/shared/types';

export const setAuth = createStandardAction('APP/SET_AUTH')<Partial<Auth>>();

export const setAccessibilitySettings = createStandardAction(
  'APP/SET_ACCESSIBILITY'
)<AccessibilitySettings>();
